<div class="row text-center align-items-center mt-2">
    <ng-container *ngIf="!name; else templateNoName">
        <div class="col"><hr></div>    
    </ng-container>
    <ng-template #templateNoName>
        <div class="col-sm-3 text-center text-dark"><strong>{{name}}</strong></div>
        <hr class="col-sm-7">
    </ng-template>
</div>